export const changePasswordContent = {
  settingsPageHeading: "Change password",
  settingsPageSubheading: "You can change the password from here.",
};

export const getPasswordFields = (
  showPassword: showPasswordDataType,
  password: passwordDataType,
  passwordTouched: showPasswordDataType,
) => {
  return [
    {
      label: "Current Password",
      type: showPassword.oldPassword ? "text" : "password",
      placeholder: "Enter current password",
      name: "oldPassword",
      value: password.oldPassword,
      touched: passwordTouched.oldPassword,
    },
    {
      label: "New Password",
      type: showPassword.newPassword ? "text" : "password",
      placeholder: "Enter new password",
      name: "newPassword",
      value: password.newPassword,
      touched: passwordTouched.newPassword,
    },
    {
      label: "Confirm New Password",
      type: showPassword.confirmPassword ? "text" : "password",
      placeholder: "Re-enter new password",
      name: "confirmPassword",
      value: password.confirmPassword,
      touched: passwordTouched.confirmPassword,
    },
  ];
};
